import * as React from 'react';

import * as styles from './styles.css';

interface INewAnswerFooterProps {
  next: React.ReactElement<any>;
}

export const NewAnswerFooter = ({ next }: INewAnswerFooterProps): React.JSX.Element => {
  return (
    <div className={styles['container']}>
      <div className={styles['button']}>{next}</div>
    </div>
  );
};
